import { AnalyticsHelperService } from './../../services/analytics-helper.service';
import { Component, ViewChild, OnInit } from '@angular/core';
import { EvsbVirtualCheckupComponent } from './evsb-virtual-checkup.component';

@Component({
  selector: 'evsb-virtual-checkup-modal',
  templateUrl: './virtual-checkup-modal.component.html',
})
export class VirtualCheckupModalComponent implements OnInit {
  @ViewChild(EvsbVirtualCheckupComponent) virtualCheckupComponent: EvsbVirtualCheckupComponent;

  constructor(private analyticsHelperService: AnalyticsHelperService) {}

  public ngOnInit() {
    this.analyticsHelperService.analyticsWorkflowStep('overlay-contact-request', {
      withResult: true,
    });
  }

  public submitData() {
    this.virtualCheckupComponent.submit();
  }
}
